import { FC } from 'react';

import { IoIosInformationCircle } from 'react-icons/io';

import { useTheme } from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

import { IFormLabelProps } from './types';
import { Container } from './styles';
import { Typography } from '../Typography';
import { Badge } from '../Badge';

export const FormLabel: FC<IFormLabelProps> = ({
  label,
  sublabel = '',
  badge = '',
  description = '',
  isDisabled = false,
  isRequired = false,
  hint = '',
}) => {
  const theme = useTheme();

  return (
    <Container>
      {(label || isRequired || sublabel || hint || badge) && (
        <header>
          {!!label && (
            <Typography.Label
              size="small"
              color={isDisabled ? 'neutral.400' : 'neutral.0'}
            >
              {label}
            </Typography.Label>
          )}

          {isRequired && (
            <Typography.Label size="small" color="green.500">
              *
            </Typography.Label>
          )}

          {sublabel && (
            <Typography.Paragraph
              size="x-small"
              color={isDisabled ? 'neutral.500' : 'neutral.400'}
            >
              {sublabel}
            </Typography.Paragraph>
          )}

          {!!hint && (
            <IoIosInformationCircle
              size={14}
              color={theme.neutral[isDisabled ? 500 : 400]}
            />
          )}

          {!!badge && <Badge color="primary">{badge}</Badge>}
        </header>
      )}

      <div>
        {!!description && (
          <Typography.Paragraph
            size="x-small"
            color={isDisabled ? 'neutral.500' : 'neutral.400'}
            style={{
              marginTop: SPACING._8,
            }}
          >
            {description}
          </Typography.Paragraph>
        )}
      </div>
    </Container>
  );
};
